import { ReactNode } from "react";
import type { LunimarRealm } from "./lunimarRealms";

interface Props {
  realm: LunimarRealm;
  children: ReactNode;
  className?: string;
}

/**
 * Layered glass mission panel — replaces the flat centered card. Edges
 * carry a subtle accent glow tied to the realm so the surface feels like
 * a floating holographic console rather than a form on a dark page.
 */
const MissionPanel = ({ realm, children, className = "" }: Props) => {
  return (
    <div className={`relative ${className}`}>
      {/* Outer glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-px rounded-3xl opacity-70"
        style={{
          background: `linear-gradient(135deg, hsl(${realm.primaryAccent} / 0.35), transparent 40%, hsl(${realm.secondaryAccent} / 0.3))`,
          filter: "blur(14px)",
        }}
      />
      <div
        className="relative overflow-hidden rounded-3xl border border-white/10 bg-[hsl(228_45%_12%/0.66)] p-4 backdrop-blur-lg sm:p-6 md:p-8"
        style={{
          boxShadow:
            "inset 0 1px 0 hsl(0 0% 100% / 0.06), 0 30px 60px -30px hsl(230 60% 4% / 0.7)",
        }}
      >
        {/* Inner accent edge */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-6 top-0 h-px"
          style={{
            background: `linear-gradient(90deg, transparent, hsl(${realm.primaryAccent} / 0.6), transparent)`,
          }}
        />
        {children}
      </div>
    </div>
  );
};

export default MissionPanel;